import { Schema } from 'effect';

import {
  AddToCartButtonElementDTOjsonldsyliusshoparticleshow,
  AddToCartButtonElementDTOjsonldsyliusshoppageshow,
  AdvantagesElementDTOjsonldsyliusshoparticleshow,
  AdvantagesElementDTOjsonldsyliusshopglossaryshow,
  AdvantagesElementDTOjsonldsyliusshoppageshow,
  BaseButtonElementDTOjsonldsyliusshoparticleshow,
  BaseButtonElementDTOjsonldsyliusshopglossaryshow,
  BaseButtonElementDTOjsonldsyliusshoppageshow,
  ButtonGridElementDTOjsonldsyliusshoparticleshow,
  ButtonGridElementDTOjsonldsyliusshopglossaryshow,
  ButtonGridElementDTOjsonldsyliusshoppageshow,
  FaqQuestionjsonldsyliusshopfaqquestionshow,
  FaqQuestionsyliusshopfaqquestionshow,
  GoogleMapsElementDTOjsonldsyliusshoppageshow,
  ImageCollectionElementDTOjsonldsyliusshoparticleshow,
  ImageCollectionElementDTOjsonldsyliusshopglossaryshow,
  ImageCollectionElementDTOjsonldsyliusshoppageshow,
  ImageElementDTOjsonldsyliusshoparticleshow,
  ImageElementDTOjsonldsyliusshopglossaryshow,
  ImageElementDTOjsonldsyliusshoppageshow,
  ImagePairElementDTOjsonldsyliusshoparticleshow,
  ImagePairElementDTOjsonldsyliusshopglossaryshow,
  ImagePairElementDTOjsonldsyliusshoppageshow,
  MarkdownPerexElementDTOjsonldsyliusshoparticleshow,
  MarkdownTextElementDTOjsonldsyliusshoparticleshow,
  MarkdownTextElementDTOjsonldsyliusshopglossaryshow,
  MarkdownTextElementDTOjsonldsyliusshoppageshow,
  MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow,
  MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow,
  MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow,
  MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow,
  MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow,
  MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow,
  MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow,
  MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow,
  MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow,
  ProductElementDTOjsonldsyliusshoparticleshow,
  ProductElementDTOjsonldsyliusshoppageshow,
  ProductListElementDTOjsonldsyliusshoparticleshow,
  ProductListElementDTOjsonldsyliusshopglossaryshow,
  ProductListElementDTOjsonldsyliusshoppageshow,
  QuoteElementDTOjsonldsyliusshoparticleshow,
  QuoteElementDTOjsonldsyliusshopglossaryshow,
  QuoteElementDTOjsonldsyliusshoppageshow,
  RetinoWidgetElementDTOjsonldsyliusshoparticleshow,
  RetinoWidgetElementDTOjsonldsyliusshopglossaryshow,
  RetinoWidgetElementDTOjsonldsyliusshoppageshow,
  TableElementDTOjsonldsyliusshoparticleshow,
  TableElementDTOjsonldsyliusshopglossaryshow,
  TableElementDTOjsonldsyliusshoppageshow,
  TeamElementDTOjsonldsyliusshoparticleshow,
  TeamElementDTOjsonldsyliusshopglossaryshow,
  TeamElementDTOjsonldsyliusshoppageshow,
  TitleElementDTOjsonldsyliusshoparticleshow,
  TitleElementDTOjsonldsyliusshopglossaryshow,
  TitleElementDTOjsonldsyliusshoppageshow,
  WhiteBoxElementDTOjsonldsyliusshoparticleshow,
  WhiteBoxElementDTOjsonldsyliusshopglossaryshow,
  WhiteBoxElementDTOjsonldsyliusshoppageshow,
  YoutubeElementDTOjsonldsyliusshoparticleshow,
  YoutubeElementDTOjsonldsyliusshopglossaryshow,
  YoutubeElementDTOjsonldsyliusshoppageshow,
} from '../gen/rcprofi';
import { ArticleShow as ArticleShowBase } from '@vs-shop/schemas/branded/ContentSchema';
import {
  FaqQuestionShow as FaqQuestionShowBase,
  GlossaryTermShow as GlossaryTermShowBase,
  PageShow as PageShowBase,
} from '@vs-shop/schemas/branded/MiscSchema';
import { overrideSchema } from '@vs-shop/schemas/openapi/overrideSchema';

/**
 * RcProfi's exact generated CMS element and recursive-reference unions.
 * Package bases keep these closures as documented override slots; this app
 * boundary restores the validation contract that existed before extraction.
 */
const ArticleContentElement = Schema.Union(
  [
    TitleElementDTOjsonldsyliusshoparticleshow,
    MarkdownTextElementDTOjsonldsyliusshoparticleshow,
    MarkdownPerexElementDTOjsonldsyliusshoparticleshow,
    QuoteElementDTOjsonldsyliusshoparticleshow,
    ImageElementDTOjsonldsyliusshoparticleshow,
    ImageCollectionElementDTOjsonldsyliusshoparticleshow,
    ProductElementDTOjsonldsyliusshoparticleshow,
    YoutubeElementDTOjsonldsyliusshoparticleshow,
    ImagePairElementDTOjsonldsyliusshoparticleshow,
    MarkdownTwoColumnsElementDTOjsonldsyliusshoparticleshow,
    MarkdownThreeColumnsElementDTOjsonldsyliusshoparticleshow,
    MarkdownTextWithImageElementDTOjsonldsyliusshoparticleshow,
    RetinoWidgetElementDTOjsonldsyliusshoparticleshow,
    AdvantagesElementDTOjsonldsyliusshoparticleshow,
    WhiteBoxElementDTOjsonldsyliusshoparticleshow,
    TeamElementDTOjsonldsyliusshoparticleshow,
    BaseButtonElementDTOjsonldsyliusshoparticleshow,
    AddToCartButtonElementDTOjsonldsyliusshoparticleshow,
    ButtonGridElementDTOjsonldsyliusshoparticleshow,
    ProductListElementDTOjsonldsyliusshoparticleshow,
    TableElementDTOjsonldsyliusshoparticleshow,
  ],
  { mode: 'oneOf' }
);

const PageContentElement = Schema.Union(
  [
    TitleElementDTOjsonldsyliusshoppageshow,
    MarkdownTextElementDTOjsonldsyliusshoppageshow,
    QuoteElementDTOjsonldsyliusshoppageshow,
    ImageElementDTOjsonldsyliusshoppageshow,
    ImageCollectionElementDTOjsonldsyliusshoppageshow,
    ProductElementDTOjsonldsyliusshoppageshow,
    YoutubeElementDTOjsonldsyliusshoppageshow,
    ImagePairElementDTOjsonldsyliusshoppageshow,
    MarkdownTwoColumnsElementDTOjsonldsyliusshoppageshow,
    MarkdownThreeColumnsElementDTOjsonldsyliusshoppageshow,
    MarkdownTextWithImageElementDTOjsonldsyliusshoppageshow,
    RetinoWidgetElementDTOjsonldsyliusshoppageshow,
    AdvantagesElementDTOjsonldsyliusshoppageshow,
    WhiteBoxElementDTOjsonldsyliusshoppageshow,
    TeamElementDTOjsonldsyliusshoppageshow,
    GoogleMapsElementDTOjsonldsyliusshoppageshow,
    BaseButtonElementDTOjsonldsyliusshoppageshow,
    AddToCartButtonElementDTOjsonldsyliusshoppageshow,
    ButtonGridElementDTOjsonldsyliusshoppageshow,
    ProductListElementDTOjsonldsyliusshoppageshow,
    TableElementDTOjsonldsyliusshoppageshow,
  ],
  { mode: 'oneOf' }
);

/**
 * The glossary term's own element closure from the current shop schema.
 *
 * `product` and `button_add_to_cart` are absent because the backend registers
 * `sylius:shop:glossary:show` on neither DTO's properties: their generated
 * glossary variants therefore declare no `productCode` / `product` / `type` at
 * all, which in a `oneOf` union matches every block and makes the whole
 * closure ambiguous. Restoring them is a backend change — add the group to
 * those two DTOs, regenerate, and list the two names here.
 */
const GlossaryContentElement = Schema.Union(
  [
    TitleElementDTOjsonldsyliusshopglossaryshow,
    MarkdownTextElementDTOjsonldsyliusshopglossaryshow,
    QuoteElementDTOjsonldsyliusshopglossaryshow,
    ImageElementDTOjsonldsyliusshopglossaryshow,
    ImageCollectionElementDTOjsonldsyliusshopglossaryshow,
    YoutubeElementDTOjsonldsyliusshopglossaryshow,
    ImagePairElementDTOjsonldsyliusshopglossaryshow,
    MarkdownTwoColumnsElementDTOjsonldsyliusshopglossaryshow,
    MarkdownThreeColumnsElementDTOjsonldsyliusshopglossaryshow,
    MarkdownTextWithImageElementDTOjsonldsyliusshopglossaryshow,
    RetinoWidgetElementDTOjsonldsyliusshopglossaryshow,
    AdvantagesElementDTOjsonldsyliusshopglossaryshow,
    WhiteBoxElementDTOjsonldsyliusshopglossaryshow,
    TeamElementDTOjsonldsyliusshopglossaryshow,
    BaseButtonElementDTOjsonldsyliusshopglossaryshow,
    ButtonGridElementDTOjsonldsyliusshopglossaryshow,
    ProductListElementDTOjsonldsyliusshopglossaryshow,
    TableElementDTOjsonldsyliusshopglossaryshow,
  ],
  { mode: 'oneOf' }
);

const FaqRelatedQuestions = Schema.optionalKey(
  Schema.Array(
    Schema.Union([
      Schema.suspend(() => FaqQuestionjsonldsyliusshopfaqquestionshow),
      FaqQuestionsyliusshopfaqquestionshow,
      Schema.String.annotate({
        description: 'IRI on FaqQuestion when MaxDepth is exceeded',
        format: 'uri',
      }),
    ])
  ).annotate({
    description: 'First level = FaqQuestion object, deeper levels = IRI. Limited to 6 questions.',
    readOnly: true,
  })
);

export const ArticleShow = overrideSchema(ArticleShowBase, {
  content: Schema.Array(ArticleContentElement),
}).annotate({ identifier: 'ArticleShow' });
export type ArticleShow = Schema.Schema.Type<typeof ArticleShow>;

export const PageShow = overrideSchema(PageShowBase, {
  content: Schema.Array(PageContentElement),
}).annotate({ identifier: 'PageShow' });
export type PageShow = Schema.Schema.Type<typeof PageShow>;

export const GlossaryTermShow = overrideSchema(GlossaryTermShowBase, {
  content: Schema.Array(GlossaryContentElement),
}).annotate({ identifier: 'GlossaryTermShow' });
export type GlossaryTermShow = Schema.Schema.Type<typeof GlossaryTermShow>;

export const FaqQuestionShow = overrideSchema(FaqQuestionShowBase, {
  relatedQuestions: FaqRelatedQuestions,
}).annotate({ identifier: 'FaqQuestionShow' });
export type FaqQuestionShow = Schema.Schema.Type<typeof FaqQuestionShow>;
